import React from "react";
import { Activity } from "../../../models/Activity";
import { Material } from "../../../models/Material";
import { Order } from "../../../models/Order";
import { ProcurementFilter } from "../../../models/ProcurementFilter";
import { ProcurementView } from "../../../models/ProcurementView";
import { Submittal } from "../../../models/Submittal";
import { ActivityFilterInfo } from "../ActivityFilterInfo";
import { ViewInfo } from "../materialTypes";
import { ProcurementViews } from "../NewUI/Order/columns";
import { SubmittalFilterInfo } from "../SubmittalFilterInfo";
import { ProjectBasicInfo } from "./projectBasicInfo";

type LeadTimesContextType = {
    pageType: "team" | "project" | null;
    setPageType(pageType: "team" | "project" | null): void;

    filterInfo: ProcurementFilter | null;
    setFilterInfo(filterInfo: ProcurementFilter | null): void;

    activitiesFilter: ActivityFilterInfo;
    setActivitiesFilter(activitiesFilter: ActivityFilterInfo): void;

    submittalFilter: SubmittalFilterInfo;
    setSubmittalFilter(submittalFilter: SubmittalFilterInfo): void;

    viewInfo: ViewInfo | null;
    setViewInfo(viewInfo: ViewInfo): void;

    procurementViews: ProcurementViews;
    setProcurementViews(procurementViews: ProcurementViews): void;
    reloadProcurementViews(): Promise<any>;

    customProcurementViews: ProcurementView[];
    setCustomProcurementViews(customProcurementViews: ProcurementView[]): void;

    timelineChartView: boolean;
    setTimelineChartView(timelineChartView: boolean): void;

    timelineChartDayLevel: number;
    setTimelineChartDayLevel(timelineChartDayLevel: number): void;

    projectInfo(id: string | number): any | null;

    projectBasicInfos: ProjectBasicInfo[];
    projectBasicInfo(id: string | number): ProjectBasicInfo;
    reloadProjectBasicInfos(): void;

    projectsMaterials: { unique_token: string; materials: Material[] }[];
    setProjectsMaterials(projectsMaterials: { unique_token: string; materials: Material[] }[]): void;
    projectMaterials(id: string | number): Material[];
    reloadMaterials(): void;

    projectsActivities: { unique_token: string; activities: Activity[] }[];
    projectActivities(id: string | number): Activity[];
    reloadActivities(): void;

    submittals: { unique_token: string; submittals: Submittal[] }[];
    projectSubmittals(id: string | number): Submittal[];
    reloadSubmittals(): void;

    createMaterial(material: Material): Promise<Material | null>;
    updateMaterial(material: Material): Promise<Material | null>;
    deleteMaterial(material: Material): Promise<boolean>;

    createOrder(order: Order): Promise<Order | null>;
    updateOrder(order: Order): Promise<Order | null>;
    deleteOrder(order: Order): Promise<boolean>;

    materialLeadTimesSyncModal: "approve" | "submit" | "order" | "receive" | null;
    setMaterialLeadTimesSyncModal(materialLeadTimesSync: "approve" | "submit" | "order" | "receive" | null): void;

    activitiesSyncModalVisible: boolean;
    setActivitiesSyncModalVisible(visible: boolean): void;

    MaterialsChannel: any;

    previewItem: Material | Order | null;
    setPreviewItem(item: Material | Order | null): void;

    previewModalVisible: boolean;
    setPreviewModalVisible(visible: boolean): void;

    orderForId(id: number): Order | undefined;
};

// @ts-expect-error: This throws an error that null cannot initialize this type. This is true, but first use will give this a real value.
const LeadTimesContext = React.createContext<LeadTimesContextType>(null);

export default LeadTimesContext;
